<template>
  <div :class="{ 'h5-teacher-home': isH5, 'pc-teacher-home': !isH5 }">
    <div class="bg-img-wrap">
      <img
        class="bg-img-bg"
        v-if="teacherInfo.bg_img"
        :src="bgPic + '|imageMogr2/blur/50x50'"
        alt=""
      />
      <img class="bg-img" :src="bgPic" alt="背景图" />
    </div>
    <div class="page-cont">
      <div class="teacher-info-wrap">
        <img
          class="t-avatar"
          :src="teacherInfo.avatar + '?imageView2/0/w/120'"
          alt="头像"
        />
        <div class="info">
          <p class="nickname">{{ teacherInfo.org_nickname }}</p>
          <p class="intro">{{ teacherInfo.profile }}</p>
        </div>
        <button @click="handleCopyPageUrl" class="share-icon" v-preventReClick>
          <img src="../../assets/images/page-share.png" alt="" />
        </button>
      </div>
      <div class="org-info-wrap">
        <p class="title">所属机构</p>
        <div class="org-wrap" @click="jumpOrgHome">
          <img
            class="org-logo"
            :src="handleImageUrl(teacherInfo.org_logo) + '?imageView2/0/w/100'"
            alt="logo"
          />
          <div class="org-info">
            <p class="org-name">{{ teacherInfo.org_name }}</p>
            <p class="org-desc">{{ teacherInfo.category_name }}</p>
          </div>
        </div>
      </div>
      <div class="course-list">
        <p class="module-title">课程</p>
        <div class="list-wrap" v-if="courseList.length">
          <CourseCardOrg
            v-for="item in courseList"
            :key="item.id"
            :type="isH5 ? 'big' : 'small'"
            :courseInfo="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCourseList } from "@saas/server-api/src/course";
import { getTeacherHomePage } from "@saas/server-api/src/organization";
import {
  isH5,
  copyPageUrl,
  CourseCardOrg,
  handleImageUrl,
  clipboard,
  isMobile,
} from "@saas/components/src";
export default {
  data: function () {
    return {
      handleImageUrl,
      isH5: isH5(),
      teacherInfo: {},
      inIosReview: false,
      loading: false,
      page_no: 1,
      page_size: 20,
      courseList: [],
      noMore: false,
      isElectron: window.isElectron,
    };
  },
  components: {
    CourseCardOrg,
  },
  mounted() {
    // 获取教师主页信息
    this.apiGetTeacherHomePage();
    this.apiGetCourseList();
    this.$nextTick(() => {
      setTimeout(() => {
        if (window.isElectron) {
          let elMain = document.getElementById("electron-main");
          if (!elMain) return;
          elMain.addEventListener("scroll", this.handleElScrollFn, true);
        } else {
          window.addEventListener("scroll", this.scrollFn, true); //监听页面滚动
        }
      }, 2000);
    });
  },
  beforeDestroy() {
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.handleElScrollFn, true);
    } else {
      window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
    }
  },
  created() {
    this.inIosReview = this.$route.query?.inReview === "1";
  },
  methods: {
    handleCopyPageUrl() {
      if (window.isElectron) {
        let content = `${process.env.VUE_APP_SAAS_WEB_URL}/t/${this.$route.params.user_id}`;
        clipboard(content, () => {
          this.$showToast("链接已复制，可以发给好友啦");
        });
      } else {
        copyPageUrl("老师主页链接已复制至粘贴板");
      }
    },
    handleElScrollFn(event) {
      if (this.loading || this.noMore) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.loading = true;
        this.page_no++;
        this.apiGetCourseList();
      }
    },
    scrollFn() {
      if (this.loading) return false;
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        if (!this.noMore) {
          this.page_no++;
          this.apiGetCourseList();
        }
      }
    },
    jumpOrgHome() {
      let url = `/org/${this.teacherInfo.org_id}`;
      if (this.$route.query?.inReview === "1") {
        url = `${url}?inReview=1`;
      }
      if (window.isElectron || isMobile()) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    apiGetTeacherHomePage() {
      let params = {
        user_id: this.$route.params.user_id,
      };
      getTeacherHomePage(params).then((res) => {
        if (res.code === 1) {
          this.teacherInfo = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiGetCourseList() {
      this.loading = true;
      let params = {
        page_no: this.page_no,
        page_size: this.page_size,
        create_user_id: this.$route.params.user_id,
      };
      getCourseList(params)
        .then((res) => {
          if (res.code === 1) {
            if (res.data?.list) {
              if (params.page_no === 1) {
                this.courseList = res.data.list;
              } else {
                this.courseList = this.courseList.concat(res.data.list);
              }
              if (this.courseList.length === res.data.total) {
                this.noMore = true;
              } else {
                this.noMore = false;
              }
            }
          } else {
            this.$message.error(res.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    bgPic() {
      if (this.teacherInfo?.bg_img) {
        return this.teacherInfo?.bg_img + "?imageView2/0/w/1000";
      } else {
        return require("../../assets/images/organization/org_bg.png");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-teacher-home {
  min-height: calc(100vh - 238px);
  background: #fafafa;
  .bg-img-wrap {
    position: relative;
    background: #d4f1e1;
    height: 340px;
    .bg-img-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .bg-img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 800px;
      height: 340px;
      object-fit: cover;
    }
  }
  .page-cont {
    position: relative;
    top: -20px;
    max-width: 800px;
    width: 800px;
    margin: 0 auto;
    padding-bottom: 5px;
  }
  .teacher-info-wrap {
    // margin-bottom: 20px;
    position: relative;
    top: -20px;
    min-height: 120px;
    background: #ffffff;
    border-radius: 24px;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    .t-avatar {
      width: 80px;
      height: 80px;
      border-radius: 16px;
      margin-right: 16px;
    }
    .info {
      flex: 1;
      width: 0;
    }
    .nickname {
      font-weight: 500;
      font-size: 20px;
      color: #000000;
      line-height: 28px;
      margin-bottom: 6px;
    }
    .intro {
      font-weight: 400;
      font-size: 16px;
      color: #515350;
      line-height: 22px;
      word-break: break-all;
      line-break: anywhere;
    }
  }
  .share-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    width: 20px;
    height: 20px;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .org-info-wrap {
    height: 151px;
    background: #ffffff;
    border-radius: 24px;
    padding: 20px 24px 0;
    margin-bottom: 30px;
    .title {
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      line-height: 25px;
      margin-bottom: 12px;
    }
  }
  .org-wrap {
    cursor: pointer;
    width: 100%;
    height: 74px;
    background: #fafafa;
    border-radius: 8px;
    padding: 12px 22px 12px 12px;
    display: flex;
    align-items: center;
    .org-logo {
      width: 50px;
      height: 50px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #e2e2e2;
      margin-right: 8px;
      object-fit: cover;
    }
    .org-info {
      flex: 1;
      width: 0;
    }
    .org-name {
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      line-height: 22px;
      margin-bottom: 4px;
      word-break: break-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .org-desc {
      font-weight: 400;
      font-size: 14px;
      color: #515350;
      line-height: 20px;
      word-break: break-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .course-list {
    .module-title {
      font-weight: 600;
      font-size: 18px;
      color: #0d1400;
      line-height: 25px;
      margin-bottom: 20px;
    }
    .list-wrap {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
}
.h5-teacher-home {
  background: #fafafa;
  width: 100%;
  min-height: 100vh;
  .bg-img-wrap {
    position: relative;
    background: #d4f1e1;
    height: 4.24rem;
    .bg-img-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .bg-img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 10rem;
      height: 4.24rem;
      object-fit: cover;
    }
  }
  .page-cont {
    position: relative;
    top: -0.1rem;
    max-width: 100%;
    width: 100%;
    margin: 0 auto;
    padding: 0 0.32rem;
  }
  .teacher-info-wrap {
    position: relative;
    top: -0.27rem;
    max-width: 100%;
    width: 100%;
    margin: 0 auto;
    padding: 0.32rem 1rem 0.32rem 0.32rem;
    display: flex;
    min-height: 1.84rem;
    background: #ffffff;
    border-radius: 0.32rem;
    .t-avatar {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 0.21rem;
      margin-right: 0.16rem;
      object-fit: cover;
    }
    .info {
      flex: 1;
      width: 0;
      .nickname {
        font-weight: 500;
        font-size: 0.4rem;
        color: #0d1400;
        line-height: 0.56rem;
        margin-bottom: 0.13rem;
        word-break: break-all;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .intro {
        font-weight: 400;
        font-size: 0.29rem;
        color: #515350;
        line-height: 0.4rem;
        word-break: break-all;
        line-break: anywhere;
      }
    }
  }
  .share-icon {
    position: absolute;
    top: 0.47rem;
    right: 0.27rem;
    width: 0.37rem;
    height: 0.37rem;
    img {
      width: 0.37rem;
      height: 0.37rem;
    }
  }
  .org-info-wrap {
    margin-bottom: 0.4rem;
    width: 100%;
    height: 3.17rem;
    background: #ffffff;
    border-radius: 0.32rem;
    padding: 0.32rem 0.32rem 0;
    .title {
      font-weight: 500;
      font-size: 0.4rem;
      color: #000000;
      line-height: 0.56rem;
      margin-bottom: 0.27rem;
    }
    .org-wrap {
      display: flex;
      align-items: center;
      height: 1.71rem;
      background: #fafafa;
      border-radius: 0.21rem;
      padding: 0.32rem 0.45rem 0.32rem 0.32rem;
      .org-logo {
        width: 1.07rem;
        height: 1.07rem;
        background: #ffffff;
        border-radius: 0.21rem;
        border: 0.01rem solid #e2e2e2;
        object-fit: cover;
        margin-right: 0.13rem;
      }
    }
    .org-info {
      flex: 1;
      width: 0;
      .org-name {
        font-weight: 500;
        font-size: 0.37rem;
        color: #000000;
        line-height: 0.53rem;
        margin-bottom: 0.08rem;
      }
      .org-desc {
        font-weight: 400;
        font-size: 0.29rem;
        color: #515350;
        line-height: 0.4rem;
      }
    }
  }
  .course-list {
    .module-title {
      font-weight: 500;
      font-size: 0.37rem;
      color: #0d1400;
      line-height: 0.53rem;
      margin-bottom: 0.27rem;
    }
  }
}
</style>
